import { createAction } from 'redux-actions';
import { INTERACTION_MODE } from 'pxc-editor-material-svg-rendering/constants';
import { SET_PAGINATION_PAGE_NUM, PAGINATION_PAGE_SIZE } from '@/constants';
import {
  getPaginationPageItemsByPage,
  getPaginationTotalPagesNum
} from '@/helpers';
import { setSelectedPage } from "./page";
import { addSectionToMatrixSelection, clearSectionsSelection, clearShieldsSelection, setCmmeStates, setPageChildrenBasedOnContent } from "./main";
import { centerViewbox } from "./rendererView";

const _setPageNum = pageNum => dispatch => {
  dispatch(createAction(SET_PAGINATION_PAGE_NUM, () => pageNum)());
};

const _handleSelectionAfterChange = ({ selItemUid = null, isSectionSelection = true }) => (dispatch, getState) => {
  const { core: { mode, paginationPageNum, pages, pagesOrder, pagesSelection, cmmeStates } } = getState();

  let pageToSelect = null;
  //// make first item on page as selected globally, if selected isn't between items of page
  const paginationPageUids = getPaginationPageItemsByPage(pagesOrder, paginationPageNum);
  if (paginationPageUids.length) {
    if (selItemUid && pagesSelection.indexOf(selItemUid) < 0 && pages[selItemUid]) {
      pageToSelect = pages[selItemUid];
    } else if (paginationPageUids.indexOf(pagesSelection[0]) < 0) {
      pageToSelect = pages[paginationPageUids[0]];
    }
  }

  let sectionsSelection = null;

  if (pageToSelect) {
    switch (mode) {
      case INTERACTION_MODE.EDIT:
        const cmmeStatesOld = cmmeStates? JSON.parse(JSON.stringify(cmmeStates)) : null;
        dispatch(clearSectionsSelection());
        dispatch(clearShieldsSelection());

        if (cmmeStatesOld) {
          dispatch(setCmmeStates(cmmeStatesOld));
          sectionsSelection = cmmeStatesOld.pages && cmmeStatesOld.pages[pageToSelect.uid] ? cmmeStatesOld.pages[pageToSelect.uid].sectionsSelection : null;
        }

        break;
      default:
        break;
    }
    dispatch(setSelectedPage({ pageUid: pageToSelect.uid, isSectionSelection }));
    if (!!sectionsSelection && Object.keys(sectionsSelection)?.length > 1) {
      setTimeout(() => {
        Object.keys(sectionsSelection).forEach(secid => {
          dispatch(addSectionToMatrixSelection(pageToSelect.sections[secid]));
        });
      }, 10);
    }
    setTimeout(() => {
      dispatch(setPageChildrenBasedOnContent(pageToSelect.uid));
    }, 0);
  }

  dispatch(centerViewbox());
};

export const paginationToStart = () => dispatch => {
  dispatch(_setPageNum(1));
  dispatch(_handleSelectionAfterChange({}));
};

export const paginationToNextPage = () => (dispatch, getState) => {
  const { core: { paginationPageNum, pagesOrder } } = getState();
  if (getPaginationTotalPagesNum(pagesOrder) > paginationPageNum) {
    dispatch(_setPageNum(paginationPageNum + 1));
    dispatch(_handleSelectionAfterChange({}));
  }
};

export const paginationToPrevPage = () => (dispatch, getState) => {
  const { core: { paginationPageNum } } = getState();
  if (paginationPageNum > 1) {
    dispatch(_setPageNum(paginationPageNum - 1));
    dispatch(_handleSelectionAfterChange({}));
  }
};

export const paginationGoToPage = (newPageNum, isSectionSelection = true) => (dispatch, getState) => {
  const { core: { paginationPageNum, pagesOrder } } = getState();
  let res = newPageNum;
  if (res < 1) {
    res = 1
  } else {
    const totalNum = getPaginationTotalPagesNum(pagesOrder);
    if (newPageNum > totalNum) {
      res = totalNum;
    }
  }

  if (res !== paginationPageNum) {
    dispatch(_setPageNum(res));
    dispatch(_handleSelectionAfterChange({ isSectionSelection }));
  }
};

export const paginationSetByPageItem = (findUid, force=false) => (dispatch, getState) => {
  const { core: { pagesOrder, paginationPageNum } } = getState();
  const itemIndex = pagesOrder.findIndex(el => el === findUid);

  if (itemIndex >= 0) {
    const pageSize = PAGINATION_PAGE_SIZE;
    const newPageNum = Math.ceil((itemIndex + 1) / pageSize);
    if (force || newPageNum !== paginationPageNum) {
      if (newPageNum !== paginationPageNum) {
        dispatch(_setPageNum(newPageNum));
      }
      dispatch(_handleSelectionAfterChange({ selItemUid: findUid }));
    }
  }
};